const REGISTRATION_CATEGORY_KEY = 'registrationCategory';

/**
 * Sets the registration category in sessionStorage.
 * This is used to track where the user initiated the sign-up process.
 * @param category - The category of the registration location (e.g., 'header', 'campaigns_list').
 */
export function setRegistrationCategory(category: string) {
  sessionStorage.setItem(REGISTRATION_CATEGORY_KEY, category);
}

/**
 * Retrieves the registration category from sessionStorage.
 * @returns The registration category string, or null if it's not set.
 */
export function getRegistrationCategory(): string | null {
  return sessionStorage.getItem(REGISTRATION_CATEGORY_KEY);
}

/**
 * Clears the registration category from sessionStorage.
 * This should be called after the category has been used for tracking.
 */
export function clearRegistrationCategory() {
  sessionStorage.removeItem(REGISTRATION_CATEGORY_KEY);
}
